import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

function useListVehicleLoanOffersQuery() {
  const $api = useApi();
  const lendingApplicationID = useLendingApplicationID();

  return $api.useQuery(
    "get",
    "/v2/lending/vehicle_loan_offers/",
    {
      params: {
        query: {
          application: lendingApplicationID,
        },
      },
    },
    { enabled: Boolean(lendingApplicationID) }
  );
}

export { useListVehicleLoanOffersQuery };
